import AntdModal, { ModalProps as AntdModalProps } from "antd/es/modal/Modal";
import { CSSProperties, PureComponent, ReactNode } from "react";
import withCommonEvents from "../../../shared/hoc/with-common-events";
import { CommonProps } from "../common/common-props";

interface ModalProps extends AntdModalProps {
  height: string;
  // Code generation emits a purely-numeric fixed value ("20") as a JSX number
  // (top={20}) and a value carrying a unit ("20px") as a string, so both arrive here.
  top?: string | number;
}

interface ModalState {}

class Modal extends PureComponent<ModalProps & CommonProps, ModalState> {
  // Unit-less values ("40") must become numbers so React appends "px";
  // as strings they'd be emitted verbatim and dropped as invalid CSS.
  private static readonly UNITLESS_VALUE_REGEX: RegExp = /^\d+(\.\d+)?$/;

  /**
   * An unset, zero or negative top means "no opinion" — leave the modal at the
   * library default position rather than pinning it to the viewport edge.
   */
  private static resolveTop(top: string | number | undefined): string | number | undefined {
    // Falsy covers unset, empty string, and the numeric/ string zero that both mean "default".
    if (!top) {
      return undefined;
    }
    const rawTop: string = String(top).trim();
    const numericTop: number = Number.parseFloat(rawTop);
    if (Number.isNaN(numericTop) || numericTop <= 0) {
      return undefined;
    }
    return Modal.UNITLESS_VALUE_REGEX.test(rawTop) ? numericTop : rawTop;
  }

  constructor(props: ModalProps) {
    super(props);
    this.state = {};
  }

  render(): ReactNode {
    let height = "70vh";
    if (this.props.height) {
      height = this.props.height;
    }

    const className = this.props.className ? `kuika-modal ${this.props.className}` : "kuika-modal";

    const { top, centered, style, ...restProps } = this.props;
    const modalStyle: CSSProperties = { ...style };
    const resolvedTop: string | number | undefined = Modal.resolveTop(top);
    if (resolvedTop !== undefined && centered !== true) {
      modalStyle.top = resolvedTop;
    }
    const hasModalStyle: boolean = Object.keys(modalStyle).length > 0;

    return (
      <>
        <AntdModal
          bodyStyle={{ height, overflow: height ? "hidden" : "auto" }}
          {...restProps}
          centered={centered}
          style={hasModalStyle ? modalStyle : undefined}
          destroyOnClose={true}
          maskClosable={this.props.closable}
          keyboard={this.props.closable}
          className={className}
        ></AntdModal>
      </>
    );
  }
}

const modal = withCommonEvents(Modal);
export { modal as Modal };
